interface TrustScoreDisplayProps {
  score: number;
  size?: "sm" | "md" | "lg";
  showLabel?: boolean;
}

function getScoreColor(score: number): string {
  if (score < 40) return "text-red-400";
  if (score <= 70) return "text-yellow-400";
  return "text-green-400";
}

function getBarColor(score: number): string {
  if (score < 40) return "bg-red-500";
  if (score <= 70) return "bg-yellow-500";
  return "bg-green-500";
}

export function TrustScoreDisplay({ score, size = "md", showLabel = true }: TrustScoreDisplayProps) {
  const rounded = Math.round(score);
  const textSize = size === "sm" ? "text-sm" : size === "lg" ? "text-2xl" : "text-lg";
  const barHeight = size === "sm" ? "h-1" : size === "lg" ? "h-2.5" : "h-1.5";

  return (
    <div className="flex items-center gap-2">
      <span className={`font-bold ${textSize} ${getScoreColor(rounded)}`}>
        {rounded}
      </span>
      {showLabel && <span className="text-white/40 text-xs">/100</span>}
      <div className={`flex-1 ${barHeight} bg-white/10 rounded-full overflow-hidden min-w-[40px]`}>
        <div
          className={`${barHeight} ${getBarColor(rounded)} rounded-full transition-all`}
          style={{ width: `${rounded}%` }}
        />
      </div>
    </div>
  );
}
